'use client';
import { SessionProvider, SessionProviderProps } from 'next-auth/react';

const TWO_MINUTES_AND_HALF = 2 * 60 + 30;

export const ClientSessionProvider = ({
  children,
  ...props
}: SessionProviderProps) => (
  <SessionProvider {...props} refetchInterval={TWO_MINUTES_AND_HALF}>
    {children}
  </SessionProvider>
);
